<template>
  <div class="dynamic-banner">
    <img :src="mobiledynamicBanner" alt="" />
    <div class="absolute">
      <div class="title">资讯动态</div>
      <div class="text">获取最新行业新闻 了解畅月物业实时动态</div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobiledynamicBanner from '../../../assets/dynamic/mobiledynamicBanner.png'

export default {
  setup() {
    return reactive({
      mobiledynamicBanner:mobiledynamicBanner
    })
  }
};
</script>

<style scoped>
.dynamic-banner {
  position: relative;
}
.dynamic-banner img {
  width: 100%;
  height: 160px;
}
.absolute {
  width: 92vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  text-align: center;
}
.absolute .title {
  font-size: 20px;
  color: #fff ;
}
.absolute .text {
  font-size: 12px;
  margin-top: 10px;
  color: #fff ;
}
</style>
